import CheckOutlinedIcon from "@mui/icons-material/CheckOutlined";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import MyLocationOutlinedIcon from "@mui/icons-material/MyLocationOutlined";
import {
    Box,
    IconButton,
    LinearProgress,
    Stack,
    SxProps,
    Tooltip,
    Typography,
} from "@mui/material";
import { useTheme } from '@mui/material/styles';
import { noop } from "lodash";
import { FC, memo } from "react";
import IwButton from "../../app/IwButton";
import MaterialSpeakerModal from "./material-speaker-modal";

interface TranscriptionEditorHeaderProps {
    sx?: SxProps;
    isEditing: boolean;
    isSaving: boolean;
    slateData: any[];
    transcriptDataURL: string;
    onEditEnd?: () => void;
    onLocateActiveWord?: () => void;
}

const TranscriptionEditorHeader: FC<TranscriptionEditorHeaderProps> = (
    props
) => {
    const {
        sx,
        isEditing,
        isSaving,
        slateData,
        transcriptDataURL,
        onEditEnd,
        onLocateActiveWord,
    } = props;
    const theme = useTheme();
    return (
        <Stack
            className="dirty-insight-editor-clickblocker-effect--deactivate"
            direction="row"
            sx={{
                ...sx,
                padding: "0 12px",
                alignItems: "center",
                position: "relative",
                borderBottom: `1px solid ${theme.custom.borderGrey}`,
            }}
            spacing={1}
        >
            {/* <Typography sx={{ fontWeight: 700 }}>Transcription Editor</Typography> */}
            <Typography sx={{ fontWeight: 700 }}>Transcript</Typography>
            {isEditing && (
                <Stack
                    sx={{
                        boxShadow: `0 0 0 1px ${theme.custom.mainButtonHighlight}`,
                        color: theme.custom.mainButtonHighlight,
                        fontSize: "12px",
                        padding: "4px 8px",
                        fontWeight: 600,
                        // borderRadius: "4px",
                        alignItems: "center",
                        justifyContent: "center",
                        opacity: isEditing ? 1 : 0,
                    }}
                >
                    Editing
                </Stack>
            )}
            {isSaving && (
                <Box
                    component="span"
                    sx={{
                        fontSize: "12px",
                        opacity: 0.6,
                        marginLeft: "12px !important",
                    }}
                >
                    Saving...
                </Box>
            )}
            <Stack
                direction="row"
                sx={{ marginLeft: "auto !important" }}
            >
                <Tooltip title="Scroll playback location into view">
                    <IconButton
                        onClick={() => {
                            onLocateActiveWord();
                        }}
                    >
                        <MyLocationOutlinedIcon />
                    </IconButton>
                </Tooltip>
                <MaterialSpeakerModal
                    slateData={slateData}
                    transcriptDataURL={transcriptDataURL}
                />
            </Stack>
            <IwButton
                variant="outlined"
                size="small"
                startIcon={isEditing ? <CheckOutlinedIcon /> : <EditOutlinedIcon />}
                sx={{
                    height: "32px",
                }}
                onClick={() => {
                    onEditEnd();
                }}
            >
                {isEditing ? "Done" : "Edit"}
            </IwButton>
            {isSaving && (
                <LinearProgress
                    sx={{
                        position: "absolute",
                        width: "100%",
                        left: 0,
                        bottom: "-4px",
                        marginLeft: "0 !important",
                    }}
                />
            )}
        </Stack>
    );
};

TranscriptionEditorHeader.defaultProps = {
    sx: {},
    onEditEnd: noop,
    onLocateActiveWord: noop,
};

export default memo(TranscriptionEditorHeader);
